module.exports = "/_next/static/images/vn-acbd7b77af9fb9fa4ced00686d07d0c5.svg";